module.exports = __webpack_public_path__ + "media/images/result_sets/circles/3r4n6r9r-f3f9e7983a06d2c1204e1d9875db8b6b.svg";